import twConfig from "../../../tailwind.config";
import { THEMES } from "../constants";

interface TwColor {
    default: string;
    dark?: string;
    light?: string;
    darker?: string;
    lighter?: string;
    yellow?: string;
}

interface TwColorPalette {
    primary: TwColor;
    secondary: TwColor;
    neutral: TwColor;
    success: TwColor;
    warning: TwColor;
    error: TwColor;
    info: TwColor;
    accent: TwColor;
}

export const getColorWithOpacity = (hex: string, alpha: number) =>
    `${hex}${Math.floor(alpha * 255)
        .toString(16)
        // @ts-ignore
        .padStart(2, 0)}`;

export const getTailwindCustomColors = () => {
    const twColors = twConfig.theme?.extend?.colors;
    //@ts-ignore
    return twColors as TwColorPalette;
};

export const getColorMix = (colorMix: string, theme: string) => {
    // Extract the color-mix strings using a regular expression
    const matches = colorMix.match(/color-mix\(.*?\)/g);

    if (!Array.isArray(matches) || matches.length < 2) {
        return null;
    }

    // Return the first color-mix for light theme or the one containing 'black' for dark theme
    return theme === THEMES.LIGHT ? matches[0] : matches[1];
};
